<template>
  <qx-card title="主卡管理">
    <section slot="titleRight">
      <qx-permpisions :permpisions="this.$route.path.includes('gasCard')?'1005050101':'1005030501'">
        <el-button type="primary" plain @click="() => toEdit()">新增</el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
<!--            <section slot-scope="scope">-->
<!--              <section v-if="scope.column.property === 'oilCardTypeName'">-->
<!--                <span v-if="scope.row.oilCardType===6 && scope.row.cardTypeRemark">{{scope.row.cardTypeRemark}}</span>-->
<!--                <span v-else>{{scope.row.oilCardTypeName}}</span>-->
<!--              </section>-->
<!--              <section v-else>{{ scope.row[scope.column.property] }}</section>-->
<!--            </section>-->

          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="210"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :maxLength="3"
                :btnList="[
                  {
                    permpisions: $route.path.includes('gasCard')?'1005050102':'1005030502',
                    showCondition: true,
                    name: '申请充值',
                    event: () => toRecharge(scope.row),
                  },
                  {
                    permpisions:  $route.path.includes('gasCard')?'1005050103':'1005030503',
                    showCondition: true,
                    name: '账户明细',
                    event: () => toDetail(scope.row),
                  },
                  {
                    permpisions:  $route.path.includes('gasCard')?'1005050104':'1005030504',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemove(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <MasterCardManageDialog
      ref="masterCardManageDialog"
      @sub="masterCardManageDialogSub"
    />
    <RechargeDialog ref="rechargeDialog" @sub="rechargeDialogSub" />
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import MasterCardManageDialog from './masterCardManageDialog';
import RechargeDialog from './rechargeDialog';
import {
  doQueryParent,
  removeParentOil,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
    MasterCardManageDialog,
    RechargeDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'companyName', label: '服务商'},
          {prop: 'oilCardTypeName', label: '卡类型'},
          {prop: 'oilCarNum', label: '主卡卡号'},
          {prop: 'cardBalanceStr', label: '主卡余额'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryParent,
    toEdit () {
      this.$refs.masterCardManageDialog.show({
        cardType: 1,
      });
    },
    toRecharge (item) {
      this.$refs.rechargeDialog.show(item);
    },
    toDetail (item) {
      if (this.$route.path.includes('gasCard')) {
        this.jump({
          label: '主卡账户明细',
          url: `/manage/service/gasCard/masterCardManageDetail?oilCardNum=${item.oilCarNum}`,
        });
      } else {
        this.jump({
          label: '主卡账户明细',
          url: `/manage/service/oil/masterCardManageDetail?oilCardNum=${item.oilCarNum}`,
        });
      }
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除【${item.oilCarNum}】这张卡吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await removeParentOil({
          cardId: item.cardId,
          cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
    masterCardManageDialogSub () {
      this.getData();
    },
    rechargeDialogSub () {
      this.getData();
    },
  },
  created () {
    if (this.$route.path.includes('gasCard')) {
      let Index;
      this.tableData.title.forEach((item, index) => {
        if (item.prop === 'oilCardTypeName') {
          Index = index;
        }
      });
      this.tableData.title.splice(Index + 1, 0, { prop: 'cardTypeRemark', label: '类型备注' },);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
